import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import PageHeader from "@/components/PageHeader";
import PackageCalculator from "@/components/PackageCalculator";
import PricingEditor from "@/components/PricingEditor";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Settings2, Calculator as CalcIcon } from "lucide-react";

export default function Calculator() {
  const [searchParams] = useSearchParams();
  const initialTab = searchParams.get("tab") === "edit" ? "edit" : "calculator";
  const [tab, setTab] = useState(initialTab);

  return (
    <div>
      <PageHeader
        eyebrow="Sales & Packages"
        title="Umrah Calculator & Pricing"
        subtitle="Calculate quotes and manage package prices, room options & add-ons"
        image="https://images.unsplash.com/photo-1720549973451-018d3623b55a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxtdXNsaW0lMjBwaWxncmltYWdlJTIwbWVjY2F8ZW58MHx8fHwxNzkwMzQ4MDMzfDA&ixlib=rb-4.1.0&q=85"
        action={
          <div className="flex gap-2">
            <Button
              onClick={() => setTab("edit")}
              data-testid="edit-pricing-header-btn"
              className={`${tab === "edit" ? "bg-gold text-[#0a2e22]" : "bg-card/70 border border-gold/40 text-gold hover:bg-gold/15"} font-semibold gap-1.5 text-xs h-9`}
            >
              <Settings2 className="w-4 h-4" /> Edit Packages & Pricing
            </Button>
          </div>
        }
      />

      <div className="p-4 sm:p-8 space-y-5">
        <Tabs value={tab} onValueChange={setTab} className="w-full">
          <TabsList className="bg-card/50 border border-gold/30 p-1 mb-4">
            <TabsTrigger value="calculator" className="gap-2 data-[state=active]:bg-gold data-[state=active]:text-[#0a2e22] font-semibold text-xs">
              <CalcIcon className="w-3.5 h-3.5" /> Quote Calculator
            </TabsTrigger>
            <TabsTrigger value="edit" className="gap-2 data-[state=active]:bg-gold data-[state=active]:text-[#0a2e22] font-semibold text-xs">
              <Settings2 className="w-3.5 h-3.5" /> Edit Packages & Pricing
            </TabsTrigger>
          </TabsList>

          <TabsContent value="calculator" className="mt-0 space-y-4">
            <div className="flex items-center justify-between p-3 rounded-xl bg-gradient-to-r from-primary/50 to-card border border-gold/30">
              <span className="text-xs text-white">Need to add new packages or update room prices?</span>
              <Button size="sm" onClick={() => setTab("edit")} className="bg-gold text-[#0a2e22] font-semibold text-xs h-7 gap-1">
                <Settings2 className="w-3 h-3" /> Edit Pricing Here
              </Button>
            </div>
            <Card className="p-5 bg-card/30 border-border/60">
              <PackageCalculator />
            </Card>
          </TabsContent>

          <TabsContent value="edit" className="mt-0">
            <Card className="p-6 bg-card/40 border-gold/30 max-w-4xl">
              <div className="mb-4 pb-3 border-b border-border/60 flex items-center justify-between">
                <div>
                  <h2 className="font-serif text-lg font-semibold text-white">Edit Packages, Rooms & Add-ons</h2>
                  <p className="text-xs text-muted-foreground">Add custom Umrah packages, change rates, room surcharges and visa fees.</p>
                </div>
                <Button variant="outline" size="sm" onClick={() => setTab("calculator")} className="text-xs border-gold/40 text-gold">
                  Back to Calculator
                </Button>
              </div>
              <PricingEditor onSaved={() => setTab("calculator")} />
            </Card>
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
